exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropdown:hover > .dropdown-menu {\n  display: block;\n}\n.shas-dropdown .dropdown-menu {\n  margin: 0;\n  border: 0;\n  padding: 0;\n  min-width: 100%;\n  font-size: 1rem;\n}\n.shas-dropdown .dropdown-menu .dropdown-item:hover,\n.dropdown-item:focus li a {\n  background-color: unset !important;\n  font-weight: 600;\n}\n", ""]);

// exports
